import AccessLogs from './AccessLogs'

export default AccessLogs